module.exports = __webpack_public_path__ + "static/img/douLogo.b26547b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/doudouImg/douLogo.jpg
// module id = A8mU
// module chunks = 1